import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase configuration
// IMPORTANT: Replace these values with your actual Firebase project credentials
// To get these values:
// 1. Go to https://console.firebase.google.com/
// 2. Create a new project or select existing one
// 3. Go to Project Settings > General > Your apps
// 4. Add a web app and copy the configuration
const firebaseConfig = {
  apiKey: "AIzaSyDJUdJO4NQZP26t2pwGGQaotZEFcp7h9yw",
  authDomain: "beti-bachao-beti-padhao-c1c23.firebaseapp.com",
  projectId: "beti-bachao-beti-padhao-c1c23",
  storageBucket: "beti-bachao-beti-padhao-c1c23.firebasestorage.app",
  messagingSenderId: "318878996695",
  appId: "1:318878996695:web:d68258b4cafe79416df892",
  measurementId: "G-DVCVS1YWFR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

export default app;
